module.exports = __webpack_public_path__ + "static/media/others.0098c2b9.svg";